// Кэш данных авторизованного пользователя в памяти браузера (localStorage).
// Полная «история» подтягивается из JSON-файлов на backend и сохраняется локально,
// чтобы страницы открывались мгновенно и данные не терялись между сессиями.
import { api, getCachedUser } from './api';

function dataKey(userId) {
  return `kopilka_data_${userId}`;
}

// Загрузить всю историю пользователя из backend (JSON-файл) и сохранить в браузере
export async function loadAllData(userId) {
  const [categories, periods, transactions, templates, accounts] = await Promise.all([
    api.getCategories(),
    api.getPeriods(),
    api.getTransactions(),
    api.getTemplates(),
    api.getAccounts(),
  ]);
  const data = { categories, periods, transactions, templates, accounts, updatedAt: Date.now() };
  try {
    localStorage.setItem(dataKey(userId), JSON.stringify(data));
  } catch (e) { /* ignore */ }
  return data;
}

// Данные текущего пользователя из памяти браузера (или null)
export function getCachedData() {
  const user = getCachedUser();
  if (!user) return null;
  try {
    const raw = localStorage.getItem(dataKey(user.id));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

// Обновить полный кэш из backend (после изменений / при входе)
export async function refreshCache() {
  const user = getCachedUser();
  return user ? loadAllData(user.id) : Promise.resolve(null);
}

// Очистить кэш данных текущего пользователя
export function clearCachedData() {
  const user = getCachedUser();
  if (!user) return;
  try {
    localStorage.removeItem(dataKey(user.id));
  } catch (e) { /* ignore */ }
}
